import * as React from 'react';
import { useParams } from 'react-router-dom';
import { UserForm } from '.';
import { DashboardContainer } from 'views/Dashboard/components';
import { useContext, useState } from 'react';
import { Box, Button, Alert, Card, CardContent, Typography, Divider} from '@mui/material';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch} from 'react-redux';
import { selectUserById, userUpdated } from 'features/users/usersSlice';
import ContentContext from 'layouts/ContentContext'
import ScrollToContentTop from 'utils/ScrollToContentTop'
import { LinearProgress } from '@mui/material';
import { useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import parseDate from 'utils/parseDate';
import UserRolesForm from './UserRolesForm';

export default function EditUserForm(props){

    const contentDiv = useContext(ContentContext);

    console.log("User EDIT CONTEXT", contentDiv);

    const { enqueueSnackbar } = useSnackbar();
    const params = useParams();

    console.log("PARAMS", params);
    const id = params.id

    const user = useSelector((state) => selectUserById(state, id));
    console.log("User SELECTOR: ", user);
    const updateStatus = useSelector((state) => state.users.editing.status);
    const updateError = useSelector((state) => state.users.editing.error);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isSaving, setIsSaving] = useState(false);

    console.log("User EditForm Render");

    const updateUser = c => {
        const payload = { id: c.id, user: c }
        setIsSaving(true);
        dispatch(userUpdated(payload)).then(result => {
            if(result.type === "users/userUpdated/fulfilled"){
                
                setIsSaving(false);
                ScrollToContentTop(contentDiv);
                navigate("../../");
            }
            if(result.type === "users/userUpdated/rejected"){
                ScrollToContentTop(contentDiv);
                setIsSaving(false);
            }
        });    
    }

    return(
        <>
        <DashboardContainer>
            
            <Box
                sx={{
                display: 'flex',
                justifyContent: 'space-between',
                columnGap: 1
                }}
            >
                <Box>
                    <Link to="../../">
                        <Button
                        sx={{ mr: "auto" }}
                        color="success"
                        variant="outlined"
                        size="small" 
                        >
                        Back
                        </Button>
                    </Link>
                </Box>
               
            </Box>
            <Box sx={{ width: '100%', mt:3 }}>
            
            { updateError && <Alert severity="error">{updateError}</Alert>}
            { isSaving && 
                <>
                <LinearProgress />
                <Alert severity="info">STATUS : {updateStatus}</Alert>
                </>
            }   
            { user === undefined && <Alert severity="error">User with given ID does not exist.</Alert> }
            { user &&
            <>
            <Alert variant="outlined" severity="success">DATE : { parseDate(user.created_at) }</Alert>
            <Card sx={{mt:2}}>
                <CardContent>
                    <UserForm 
                        editMode={true} 
                        model={user}
                        onAction={updateUser}
                    />                   
                </CardContent>
            </Card>
            <Card sx={{mt:1}}>
                <CardContent>
                    <Typography variant="h4" component="p" sx={{mb:1}}>User roles</Typography>
                    
                    <UserRolesForm user={user} />
                </CardContent>
            </Card>
         
            </>
            }

        </Box>
        </DashboardContainer>
        </>
    )

}

